module.exports = __webpack_public_path__ + "static/media/IMG-20201016-WA0004.13688d77.jpg";